'use client';
import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

export const DialogComponent = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(220, 221, 225, 0.7)',
  },
  '& .MuiDialog-container .MuiPaper-root': {
    boxShadow: 'none',
  },

  '& .MuiDialog-paper': {
    borderRadius: '20px',
  },

  '& ::-webkit-scrollbar': {
    width: '4px',
    height: '4px',
  },
  '& ::-webkit-scrollbar-track': {
    boxShadow: `inset 0 0 6px #E9E9F4`,
    webkitBoxShadow: `inset 0 0 6px #E9E9F4`,
  },
  '& ::-webkit-scrollbar-thumb': {
    backgroundColor: '#B7BAC3',
    borderRadius: '8px',
  },
  '& ::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#888D95',
  },
}));
